import request from '@/utils/request'

export const tabledata = (m) => {
    return request({
        method: 'get',
        url :'/api/v/complete?current_month='+ m
    })
}